import TemplateSettingTab from "./templateSettingTab.container";

export default TemplateSettingTab;
